<template>
  <div class="pagination">
    <el-pagination
      background
      :class="{'dark': $isDarkTheme}"
      layout="prev, pager, next"
      :pager-count="5"
      :page-size="store.meta.per_page"
      @current-change="handlePageChange"
      hide-on-single-page
      :total="store.meta.total"
      v-bind="bindProps"
    >
    </el-pagination>
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Collection } from '@/stores';
  import _ from 'lodash';

  @Component
  export default class Pagination extends Vue {
    @Prop(Collection) store
    @Prop(Boolean) routeMode;

    get bindProps() {
      return {
        'current-page': this.routeMode ? this.$get(this.$route, 'query.page', 1) : this.$get(this.store, 'meta.page', 1)
      };
    }

    handlePageChange(page) {
      if (this.routeMode) {
        this.$router.replace({ query: _.merge({}, this.$route.query, { page }) });
        return;
      }
      this.handleFetchData(page);
    }

    @Vue.autoLoading
    handleFetchData(page) {
      return this.store.fetchData({ page });
    }
  }
</script>

<style lang="scss" scoped>
  .pagination {
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }

  ::v-deep .el-pagination {
    .btn-prev,
    .btn-next {
      font-size: 15px;
      color: var(--font-forth-blue);
      background: transparent;

      .el-icon {
        font-size: 25px;
      }
    }

    &.dark {
      .el-pager > li {
        border: none;
        color: var(--font-primary-black);
        background: var(--bg-secondary-gray);

        &:not(.disabled):hover {
          color: var(--font-forth-blue);
        }
      }
    }

    .el-pager > li {
      box-sizing: border-box;
      border: 2px solid var(--border-primary-gray);
      border-radius: 8px;
      font-weight: 600;
      font-size: 14px;
      color: var(--font-forth-blue);
      background: var(--bg-primary-white);
    }

    &.is-background .el-pager li:not(.disabled).active {
      background: var(--bg-primary-purple);
    }
  }

</style>
